import Phaser from "phaser";

export class MenuScene extends Phaser.Scene {
  constructor() {
    super("MenuScene");
  }

  create() {
    const root = document.getElementById("ui-root");
    if (!root) return;

    const wrap = document.createElement("div");
    wrap.className = "menu-panel interactive";
    wrap.innerHTML = `
      <h1>Neon Pit</h1>
      <p>3v3 core banking. Drop rivals, collect cores, stand in your vault to secure them for your crew. Original arena action — not affiliated with any commercial title.</p>
      <button type="button" class="btn-primary" data-testid="menu-play">Enter the pit</button>
    `;
    root.appendChild(wrap);

    wrap.querySelector("[data-testid='menu-play']")?.addEventListener("click", () => {
      wrap.remove();
      this.scene.start("SelectScene");
    });
  }
}
